import { defineMessages } from 'react-intl';

export const messages: {
	label: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	searchPlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	viewAllStarredItemsLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	label: {
		id: 'navigation.global-side-navigation.starred.label',
		description:
			'Label on Starred button in the side navigation. Shows a flyout with starred items.',
		defaultMessage: 'Starred',
	},
	searchPlaceholder: {
		id: 'navigation.global-side-navigation.starredSearchPlaceholder',
		description: 'Placeholder for the search input in the starred flyout list.',
		defaultMessage: 'Search starred items',
	},
	viewAllStarredItemsLabel: {
		id: 'navigation.global-side-navigation.starred.viewAllStarredLabel',
		description: 'Label on View all starred items button in the starred flyout list.',
		defaultMessage: 'View all starred items',
	},
});
